export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";